var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ne-fa-icon",class:{ 'is-brand': _vm.isBrand },style:(_vm.mergedStyle),attrs:{"title":_vm.title || _vm.icon || null,"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.iconChar))])
}
var staticRenderFns = []

export { render, staticRenderFns }